(function ($) {

    function goToSearchPage(e) {
        if (e.data.input.val().trim() && e.data.input.data('destinationUrl')) {
            var onSearchPage = window.location.pathname === e.data.input.data('destinationUrl');
            window.location.href = e.data.input.data('destinationUrl') + '#?term=' + e.data.input.val().trim();
            if (onSearchPage) {
                location.reload();
            }
        }
    }

    function validateEnterKeypress(e) {
        if (!e) {
            e = window.event;
        }

        var keyCode = null;
        if (e.keyCode) {
            keyCode = e.keyCode;
        }
        else {
            keyCode = e.charCode;
        }

        if (keyCode == 13) {
            goToSearchPage(e);
        }
    }

    $.fn.SearchBoxButtonClick = function () {
        return $(this).each(function () {
            var container = $(this).closest('.searchbox-container');
            var input = $('.searchbox-input', container);
            var button = $(this);
            button.on('click', {input: input}, goToSearchPage);
        });
    };

    $.fn.SearchBoxTextEnter = function () {
        return $(this).each(function () {
            var input = $(this);
            input.on('keypress', { input: input }, validateEnterKeypress);
        });
    };

    $(document).ready(function () {
        $('.searchbox-button').SearchBoxButtonClick();
        $('.searchbox-input').SearchBoxTextEnter();
    });

})(jQuery);